import { get, getFreeRequest } from '~/services/http-requests'

const _BS_ORDERS = 'orders'

/*
 **** GET ****
 */
function fetchOrdersClient(): Promise<IOrderClient[]> {
    return get({ baseProperty: _BS_ORDERS, fullUrl: `${_BS_ORDERS}?include[]=an_order_item_image` })
}

async function fetchSingleOrderClient(orderId: IOrder['id']): Promise<IOrder> {
    const fieldsToInclude = ['items', 'profile_address', 'profile_email', 'total_discount', 'profile_ip', 'payment_provider_charge_id']
    const mappedIncludeFields = fieldsToInclude.map(it => `include[]=${it}`).join('&')
    const [first] = await get({ baseProperty: _BS_ORDERS, fullUrl: `${_BS_ORDERS}?filter{id}=${orderId}&${mappedIncludeFields}` })
    return first
}

export { fetchOrdersClient, fetchSingleOrderClient }
